// Runtime configuration from VITE_* variables (see app/.env.example).
const DEFAULT_RPC: Record<number, string> = {
  31337: 'http://127.0.0.1:8545',
  4663: 'https://rpc.mainnet.chain.robinhood.com',
};

function parseChainId(raw: string | undefined): number {
  const n = Number(raw ?? 31337);
  return Number.isInteger(n) && n > 0 ? n : 31337;
}

export const CHAIN_ID = parseChainId(import.meta.env.VITE_CHAIN_ID);
export const RPC_URL = import.meta.env.VITE_RPC_URL || DEFAULT_RPC[CHAIN_ID] || DEFAULT_RPC[31337]!;
export const API_URL = (import.meta.env.VITE_API_URL || 'http://127.0.0.1:8787').replace(/\/+$/, '');

/** Local test accounts are offered only on the local chain, and only in dev or with VITE_DEV_WALLET=1. */
export const DEV_WALLET_ENABLED =
  CHAIN_ID === 31337 && (import.meta.env.DEV || import.meta.env.VITE_DEV_WALLET === '1');
